import gql from 'graphql-tag'

export const boothsQuery = gql`
    query booths($first: Int, $eventId: EventID!, $filters: BoothSpaceFilter, $search: String, $linkedFrom: [ID!]) {
        event(id: $eventId) {
            showBoothSidebar
            booths(first: $first, filters: $filters, search: $search, linkedFrom: $linkedFrom) {
                edges {
                    node {
                        id
                        parent {
                            slug
                            name
                            linkedFrom {
                                id
                                name
                                slug
                            }
                        }
                        boothLogo
                        companyLogo
                        subtitle
                        order
                        type
                        staffMembers {
                            id
                            email
                            hasLoggedOn
                        }
                        videos {
                            id
                        }
                        documents {
                            id
                        }
                        maxStaff
                        maxVideos
                        maxDocuments
                        maxJobOpenings
                        enableChat
                        enableVideocall
                        enableVisitorList
                        categories {
                            id
                            name
                        }
                        physicalLocation {
                            id
                        }
                    }
                }
            }
        }
    }
`

export const mapSpacesQuery = gql`
    query getMapSpaces($eventId: EventID!, $type: SpaceTypeEnum) {
        event(id: $eventId) {
            spaces(type: $type, first: 99) {
                edges {
                    node {
                        id
                        name
                    }
                }
            }
        }
    }
`

export const boothCategoriesQuery = gql`
    query getBoothCategories($eventId: EventID!) {
        event(id: $eventId) {
            boothCategories {
                id
                name
            }
        }
    }
`
